<template>
  <div class="take-explain-box">
    <div class="take-explain-info hyphenate-text">
      {{ subscribeText }}
      <span class="rule" @click="openJoinRules">{{ $t('FoodC_subscription_VPMP_seXT') }}</span>
    </div>
  </div>
</template>

<script>
import { CYCLE_TYPE } from '@/page/member/common/enumsUtil.js'
import { openJoinRules } from '@/page/member/common/utils.js'
import mixin from '@/page/member/mixins.js'

export default {
  mixin: [mixin],
  props: {
    membership: {
      default: () => {},
      type: Object,
    },
  },
  computed: {
    subscribeText() {
      let text = ''
      const info = this.membership?.assignRenewInfo || {}
      const dynamicContent = {
        brand: this.membership?.brandName, // 品牌标识
        date1: info?.expireDate || this.membership?.expireDate, // 有效期
        date2: info?.renewDate || this.membership?.renewDate, // 扣费日期
        money: info?.renewPriceSplit?.display || this.membership?.renewPriceSplit?.display, // 扣费价格
      }

      if (this.isFreeGiveStatus) {
        // 免费送文案
        text = this.$t('FoodC_subscription_eceZ_mHfd', {
          date: dynamicContent.date2,
          money: dynamicContent.money,
        })
        return text
      }

      switch (this.membership?.cycleType) {
        case CYCLE_TYPE.quarter:
          text = this.$t('FoodC_membership_fbbI_fyYa', dynamicContent)
          break
        case CYCLE_TYPE.halfYear:
          text = this.$t('FoodC_membership_aBDt_VhkX', dynamicContent)
          break
        case CYCLE_TYPE.year:
          text = this.$t('FoodC_membership_iRFJ_WWfs', dynamicContent)
          break
        default:
          text = this.$t('FoodC_subscription_eceZ_mHfd', {
            date: dynamicContent.date2,
            money: dynamicContent.money,
          })
      }
      return text
    },
  },
  methods: {
    openJoinRules,
  },
}
</script>

<style lang="scss" scoped>
.take-explain-box {
  margin-top: 48px;
  padding: 0 40px 220px 40px;
  .take-explain-info {
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #0b0b0d;
    line-height: 42px;
    font-weight: 400;
    .rule {
      font-family: DiDiSans-Pro-Bold;
      font-size: 28px;
      color: #0b0b0d;
      line-height: 42px;
      font-weight: 700;
      text-decoration: underline;
    }
  }
}
</style>
